import { Record } from "immutable";
import { DateStringNumber, Nullable } from "common/records";
import { checkDate } from "common/helpers/Date";

export type PhoneNumberSmsStatus = "subscribed" | "unsubscribed";
export const phoneFromJSON = (json: Partial<IPhoneNumberData>): PhoneNumberRecord => {
  const record: IPhoneNumberRecord = { ...(json as any) };

  if (json.created_at) {
    record.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    record.updated_at = checkDate(json.updated_at);
  }
  return new PhoneNumberRecord(record);
};

export const toJSON = (phoneNumber: PhoneNumberRecord): IPhoneNumberData => {
  const pn = phoneNumber.toJSON() as Partial<IPhoneNumberData>;

  if (!pn._destroy && pn._destroy !== undefined) {
    delete pn._destroy;
  }

  if (pn.name === "" && pn.number === "") {
    pn._destroy = true;
  }

  if (pn.id !== undefined && pn.id < 0) {
    delete pn.id;
  }

  return pn as IPhoneNumberData;
};

export interface IPhoneNumberData {
  id: number;
  name: string;
  number: string;
  status: PhoneNumberSmsStatus;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;

  _destroy?: boolean;
}

export interface IPhoneNumberRecord {
  id: Nullable<number>;
  name: Nullable<string>;
  number: Nullable<string>;
  status: PhoneNumberSmsStatus;

  created_at: Nullable<Date>;
  updated_at: Nullable<Date>;

  _destroy?: Nullable<boolean>;
}

export const defaultPhoneNumberProps = {
  id: 0,
  name: null,
  number: null,
  status: "subscribed" as PhoneNumberSmsStatus,
  created_at: null,
  updated_at: null,
  _destroy: false,
};

export class PhoneNumberRecord
  extends Record<IPhoneNumberRecord>(defaultPhoneNumberProps)
  implements IPhoneNumberRecord {}
